import {BASE_TRACK_API_URL} from "@constants/config";
import {OnShowError} from "@baseTypes/base";
import {apiRequestWithAuth} from "@helpers/query/apiRequestWithAuth";
import {
    IBodyAddSingleVoyage,
    IBodyUpdatePlannedResourcesSingleVoyage,
    IBodyUpdateSingleVoyage,
    IPropsDeleteSingleVoyage,
    IPropsStartSingleVoyage,
    IPropsStopSingleVoyage,
    IResultStartSingleVoyage,
    IResultStopSingleVoyage
} from "@containers/singleVoyage/actionsSingleVoyage/types";
import {ISingleVoyage} from "@containers/singleVoyage/types/voyage";

const BASE_URL = `${BASE_TRACK_API_URL}/v1/accounts`

export const startSingleVoyageApi = async (
    {accountId, voyageId}: IPropsStartSingleVoyage,
    onError?: OnShowError,
): Promise<IResultStartSingleVoyage> => {

    const url = `${BASE_URL}/${accountId}/single-voyages/${voyageId}/actions/start`;

    return await apiRequestWithAuth<IResultStartSingleVoyage>({
        url,
        options: {
            method: "POST",
        },
        onError
    });
}


export const stopSingleVoyageApi = async (
    {accountId, voyageId}: IPropsStopSingleVoyage,
    onError?: OnShowError,
): Promise<IResultStartSingleVoyage> => {

    const url = `${BASE_URL}/${accountId}/single-voyages/${voyageId}/actions/stop`;

    return await apiRequestWithAuth<IResultStopSingleVoyage>({
        url,
        options: {
            method: "POST",
        },
        onError
    });
}

export const deleteSingleVoyage = async (
    {id, accountId}: IPropsDeleteSingleVoyage,
    onError?: OnShowError
) => {
    const url = `${BASE_URL}/${accountId}/single-voyages/${id}`
    return await apiRequestWithAuth({
        url,
        options: {
            method: "DELETE",
        },
        onError
    });

}


export const saveSingleVoyage = async (
    body: IBodyAddSingleVoyage | IBodyUpdateSingleVoyage,
    onError?: OnShowError
): Promise<ISingleVoyage> => {
    if ('id' in body && body.id) {
        return updateSingleVoyage(body, onError)
    }
    return addSingleVoyage(body, onError)

}

export const addSingleVoyage = async (
    {
        accountId,
        ...body
    }: IBodyAddSingleVoyage,
    onError?: OnShowError
): Promise<ISingleVoyage> => {
    const url = `${BASE_URL}/${accountId}/single-voyages`
    return await apiRequestWithAuth<ISingleVoyage>({
        url,
        options: {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                'Content-type': 'application/json'
            }

        },
        onError
    });

}

export const updateSingleVoyage = async ({
                                             accountId,
                                             id,
                                             ...body
                                         }: IBodyUpdateSingleVoyage,
                                         onError?: OnShowError
): Promise<ISingleVoyage> => {
    const url = `${BASE_URL}/${accountId}/single-voyages/${id}`
    return await apiRequestWithAuth<ISingleVoyage>({
        url,
        options: {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {
                'Content-type': 'application/json'
            }

        },
        onError
    });

}


export const updatePlannedResourcesSingleVoyage = async (
    {
        accountId,
        voyageId,
        driverId,
        deviceId
    }: IBodyUpdatePlannedResourcesSingleVoyage,
    onError?: OnShowError
): Promise<ISingleVoyage> => {
    const url = `${BASE_URL}/${accountId}/single-voyages/${voyageId}/assignment`;
    return await apiRequestWithAuth<ISingleVoyage>({
        url,
        options: {
            method: "PUT",
            body: JSON.stringify({
                deviceId,
                driverId,
            }),
            headers: {
                'Content-type': 'application/json'
            }

        },
        onError
    });
}

export const archiveSingleVoyageApi = async (
    {accountId, voyageId}: IPropsStopSingleVoyage,
    onError?: OnShowError,
): Promise<void> => {

    const url = `${BASE_URL}/${accountId}/single-voyages/${voyageId}/actions/archive`;

    return await apiRequestWithAuth<void>({
        url,
        options: {
            method: "POST",
        },
        onError
    });
}
